import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { PROJECTS } from "@/content/projects";

const ProjectCard = ({ p, index }) => (
  <article className={`work-item ${index % 2 ? "is-flipped" : ""}`} data-testid={`work-item-${p.id}`}>
    <Reveal className="work-shot-wrap">
      <motion.a
        href={p.url}
        target="_blank"
        rel="noopener noreferrer"
        className="work-shot"
        whileHover={{ y: -6 }}
        transition={{ type: "spring", stiffness: 240, damping: 22 }}
        aria-label={`Visit ${p.name} website`}
        data-testid={`work-shot-${p.id}`}
      >
        <div className="browser-bar" aria-hidden="true">
          <span /><span /><span />
          <em>{p.domain}</em>
        </div>
        <div className="work-shot-img">
          <img src={p.image} alt={`${p.name} website homepage`} width="1440" height="900" loading="lazy" />
        </div>
      </motion.a>
    </Reveal>
    <Reveal delay={0.1} className="work-info">
      <p className="work-index">{String(index + 1).padStart(2, "0")} · {p.type}</p>
      <h2 className="work-name">{p.name}</h2>
      <p className="work-summary">{p.summary}</p>
      <ul className="work-tags">
        {p.tags.map((t) => <li key={t}>{t}</li>)}
      </ul>
      <a href={p.url} target="_blank" rel="noopener noreferrer" className="work-link" data-testid={`work-link-${p.id}`}>
        Visit {p.domain} <ArrowUpRight size={18} aria-hidden="true" />
      </a>
    </Reveal>
  </article>
);

export default function WorkPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Our Work | The Blake Smith Company LLC";
    return () => { document.title = "The Blake Smith Company LLC | Marketing, Websites & Mobile Apps"; };
  }, []);

  return (
    <section className="work" data-testid="work-page">
      <div className="shell">
        <header className="work-head">
          <Reveal as="p" className="founder-eyebrow">OUR WORK</Reveal>
          <Reveal as="h1" delay={0.06} className="work-title">Real businesses. <span>Real websites.</span></Reveal>
          <Reveal as="p" delay={0.12} className="work-intro">A few of the sites we’ve built for local businesses and communities. Click any project to see it live.</Reveal>
        </header>
        <div className="work-list">
          {PROJECTS.map((p, i) => <ProjectCard key={p.id} p={p} index={i} />)}
        </div>
        <Reveal className="work-cta">
          <h2>Your business could be next.</h2>
          <Link to="/#contact" className="btn btn-gold" data-testid="work-contact-btn">
            Start Your Project <ArrowRight size={18} strokeWidth={2.4} aria-hidden="true" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
